import { FlexContainer, Notification as _Notification } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Container = styled(FlexContainer)`
  width: 768px;
  padding: 0 ${({ theme: { reference } }) => `${reference.dimension_16} ${reference.dimension_16}`};
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    width: 100%;
    padding: ${({ theme: { reference } }) => reference.dimension_16};
  }
`;

export const Notification = styled(_Notification)`
  margin-bottom: ${({ theme: { system } }) => system.fds_sys_spacing_XS};
  background-color: ${({ theme: { components } }) =>
    components.messages.fds_c_messages_color_default};
  p {
    display: flex;
    align-items: center;
  }
  img {
    margin-right: ${({ theme: { system } }) => system.fds_sys_spacing_XS};
  }
`;

export const SpinnerConteiner = styled(FlexContainer)`
  height: 100%;
`;

export const ContentContainer = styled(FlexContainer)`
  gap: ${({ theme: { reference } }) => reference.dimension_40};
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    gap: 0;
  }
`;

export const ButtonContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  height: 70px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  background: ${({ theme: { colors } }) => colors.white};
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;
